import * as deloitteCookies from 'js-cookie/src/js.cookie.js';

CCL.TopNavHeader = {
  autoload: [
    ['headerValue', $('.c-main-nav').length > 0]
  ],

  headerValue() {
    const headerType = $('#headerType').val();
    window.addEventListener('unload', (event) => {
      event.preventDefault();
      deloitteCookies.set('headerType', headerType);
    });
    /* eslint-disable */
    // const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
    // const eventName = isOnIOS ? 'pagehide' : 'beforeunload';
    // if (isOnIOS) {
    //   window.addEventListener('unload', (event) => {
    //     event.preventDefault();
    //     deloitteCookies.set('headerType', headerType);
    //   });
    // } else {
    //   this.setHeaderType(headerType);
    // }
  },

  // setHeaderType(headerType) {
  //   $(window).bind('beforeunload', () => {
  //     deloitteCookies.set('headerType', headerType);
  //   });
  // }
};



// WEBPACK FOOTER //
// ./src/js/mainHeader.js